import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Routes, RouterModule } from '@angular/router';

import * as commonModules from '../modules';
import { ServicesModule } from '../services/services.module';

import { ContextMenuModule, ContextMenuService } from 'ngx-contextmenu';

import { CommonComponentsModule } from '../common-components/common-components.module';

import { ButtonsModule } from '../buttons/buttons.module';
import { FoldersModule } from '../folders/folders.module';
import { MatchModule } from '../matches/match.module';

import * as fromContainers from './containers';
import * as fromComponents from './components';
import * as fromMigrations from '../migrations';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: fromContainers.HomeComponent },
  { path: 'public/:id', component: fromContainers.PublicHostComponent },
  { path: 'playlist/:id', component: fromContainers.PlaylistViewer },
  { path: 'migrations', component: fromContainers.MigrationRunner }
];

@NgModule({
  declarations: [...fromContainers.containers, ...fromComponents.components],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    ContextMenuModule.forRoot(),
    CommonComponentsModule,
    ButtonsModule,
    FoldersModule,
    MatchModule,
    ...commonModules.modules,
    ServicesModule
  ],
  exports: [RouterModule],
  providers: [ContextMenuService, ...fromMigrations.migrations],
  entryComponents: [],
  bootstrap: [fromContainers.AppComponent]
})
export class AppModule {}
